import React from 'react';
import BaseView, {CustomFilterFrame} from '../../components/CRUDView';
import Utils, {exportFilteredCSV} from '../../common/Utils';
import {TractorOwnerEndpoints, UsersEndpoints} from '../../common/ProxyEndpoints';
import Avatar from '../../components/ProfileAvatar';
import EntityImageDisplay from "../../components/EntityImageDisplay/EntityImageDisplay";
import DialogCollapseSection from "../../components/DialogCollapseSection/DialogCollapseSection";
import {AccountTypeMap, OwnerAccountType, Permissions} from "../../common/Constants";
import HistoryLink from "../../common/HistoryLink";
import {Button, Col, Row} from "reactstrap";
import _ from "lodash";
import CreateTractorDialog from "../../components/CreateTractorDialog/CreateTractorDialog";
import WalletManagement from "../../components/WalletManagement/WalletManagement";
import DataList from "../../components/TableListView/DataList";

const SearchProps = [
    'name',
    'location',
    'user.phone'
];

const Styles ={

    inputFrame:{
        marginLeft: '5px',
        marginRight: '5px'
    }

};

const CacheDependency = [
    'dashboard',
    'tractor_operators',
    'tractors'
];

/**
 * Handles management of tractor owners by administrators
 */
class TractorOwnersAdmin extends BaseView {

    constructor(props){
        super(props,'tractor_owners_admin');
    }

    getTractorColumns(owner){
        return [
            { key: 'name' , label: 'Name' , render: (item,key) =>  <HistoryLink url={`/tractors?filter_id=${item.id}&q=${item.name}`} navigateIcon={null} className="btn-link" tooltip={"Click to see tractor"}>{item.name}</HistoryLink> },
            { key: 'registration_number' , label: 'Registration No.' },
            { key: 'operators' , label: 'Operator' , render: (item,key) => this.getTractorOperator(owner,item)},
        ];
    }

    getTractorOperator(owner, tractor){

        if(owner.operators && owner.operators.length > 0){
            let op = owner.operators.find((o) => o.tractor && o.tractor.id == tractor.id );
            if(op){
                return <HistoryLink url={`/operators?filter_id=${op.id}&q=${op.name}`} tooltip={"Click to see operator"} className="btn-link" navigateIcon={null}>{op.name}</HistoryLink>;
            }
        }

        return 'Unassigned';
    }

    renderDialogs(dialog) {
        return <React.Fragment>
            {super.renderDialogs(dialog)}
            <WalletManagement ref={r => this._walletManagementDlg = r} colCount={3}/>
            <CreateTractorDialog ref={r => this._createTractorDlg = r} onExit={tractor =>{
                this.refresh();
            }}/>
        </React.Fragment>
    }

    onExecuteRequest(endpoint,params){

        //  modify query params to append tractor id to operator payload
        let q  = params.query || (params.query = {});
        q.join_tractor_operator = true;
    }

    getCreateInputs(){

        return [
            {
                render: (k) => {
                    return <h5 key={k}>Account Info</h5>
                }
            },
            { name : 'username' , title: 'Username' , hint : 'Enter account username...' , type: 'text' , icon : 'fa fa-user' , required: true, style: Styles.inputForm },
            { name: 'password', title: 'Password' , hint: 'Enter password here. Default [username]@trotrotractor', type:'password' , icon: 'fa fa-lock', style: Styles.inputForm },
            { name : 'phone' , title: 'Phone Number' , hint : 'Enter phone number here...' , type: 'phone' , icon : 'fa fa-phone' , required: true , style: Styles.inputForm },
            { name: 'type' , title: 'Account Type', type: 'select' , format: 'number' , items: [
                {
                    value: OwnerAccountType.Individual,
                    text: "Individual",
                },
                {
                    value: OwnerAccountType.Company,
                    text: 'Company'
                }
            ]},
            //{ name : 'type' , title: 'Account Type' , type: 'select' , icon : 'fa fa-users' , items: AccountTypeMap.map((item,i) => {return { value: i , text: item };} ) , required: true },
            {
                render: (k) => {
                    return <h5 key={k}>Personal/Organizational Info</h5>
                }
            },
            { name : 'name' , title: 'Full Name' , hint : 'Enter full name here...' , type: 'text' , icon : 'fa fa-mail' , required: true, style: Styles.inputForm },
            { name : 'location' , title: 'Location' , hint : 'Enter location...' , type: 'location' , icon : 'fa fa-map-marker' , coord: {
                lat: 'location_lat',
                lng: 'location_long'
            } , style: Styles.inputForm  , required: true },
            {
                group:[
                    { name : 'email' , title: 'Email' , hint : 'Enter email here...' , type: 'email' , icon : 'fa fa-envelope' , required: false, style: Styles.inputForm },
                ],

                render: (content,key) => {
                    return <DialogCollapseSection title="Optional"  key={key} >
                        {content}
                    </DialogCollapseSection>
                }
            }
        ];

    }

    getEditInputs(){
        return [
            { name : 'username' , title: 'Username' , hint : 'Enter account username...' , type: 'text' , icon : 'fa fa-user', setValue: (input,item) => input.value = item.user.name , required: true, style: Styles.inputForm },
            { name : 'phone' , title: 'Phone Number' , hint : 'Enter phone number here...' , type: 'phone' , icon : 'fa fa-phone', setValue: (input,item) => input.value = item.user.phone  , required: true , style: Styles.inputForm },
            { name: 'type' , title: 'Account Type', type: 'select', format: 'number' , items: [
                {
                    value: OwnerAccountType.Individual,
                    text: "Individual",
                },
                {
                    value: OwnerAccountType.Company,
                    text: 'Company'
                }
            ]},
            {
                render: (k) => {
                    return <h5 key={k}>Personal/Organizational Info</h5>
                }
            },
            { name : 'name' , title: 'Full Name' , hint : 'Enter full name here...' , type: 'text' , icon : 'fa fa-mail' , setValue: (input,item) => input.value = item.name , required: true, style: Styles.inputForm },
            { name : 'location' , title: 'Location' , hint : 'Enter location...' , type: 'location' , icon : 'fa fa-map-marker' , coord: {
                lat: 'location_lat',
                lng: 'location_long'
            } , style: Styles.inputForm  , required: true },
            {
                group:[
                    { name : 'email' , title: 'Email' , hint : 'Enter email here...' , type: 'email' , icon : 'fa fa-envelope' , setValue: (input,item) => input.value = item.user.email , required: false, style: Styles.inputForm },
                ],

                render: (content,key) =>{
                    return <DialogCollapseSection title="Optional"  key={key} >
                        {content}
                    </DialogCollapseSection>
                }
            }
        ];
    }


    getCustomFilterState(filters) {

        return {
            name: filters.name || '',
            phone: filters['user.phone'] || '',
            email: filters['user.email'] || ''
        };

    }

    componentWillMount(){

        const me = this;

        this.setViewOptions({

            //  The message to show when there are no items in the view
            noRowsMessage: 'No tractor owners available yet!',

            //  The class icon for the card header
            pageIcon: 'fa fa-user-secret',

            //  The title for the content frame
            pageTitle: 'Tractor Owners',

            //  The total number of items per page
            maxItemsPerPage: 10,

            //  Defines the features of the view
            features: [ 'toolbox' , 'search' ],

            multiSelection: {

                //  enable multi-selection
                enable : false
            },

            //  defines (CRUD) actions enabled on the items
            actions:{

                //  create action options
                create:{
                    text: 'Add Tractor Owner',
                    successCreateMsg: 'Registered tractor owner successfully!',
                    failCreateMsg : 'Failed adding tractor owner!',
                    enabled: true,
                    editTitleMsg: 'Edit Tractor Owner',
                    createTitleMsg: 'Add Tractor Owner',
                    permissions:  [ Permissions.TractorOwners.Create ]
                },

                //  delete action options
                delete: {

                    enabled : false,

                    //  Disallows the deleting of many items ??
                    disallowMany: false,

                    successDeleteMsg: 'Deleted successfully!',
                    failDeleteMsg: 'Failed deleting',
                    text: 'Delete',
                    confirmTitle: 'Confirm Delete',
                    confirmMessage: 'Are you sure you want to delete tractor owner?',

                    //  The message to show when deleting many items
                    confirmManyMessage: 'Delete selected tractor owners?',
                },

                //  delete action options
                edit:{
                    enabled : true,
                    successEditMsg: 'Edited Tractor Owner successfully!',
                    failEditMsg: 'Failed editing Tractor Owner',
                    text: 'Edit Owner',
                    permissions:  [ Permissions.TractorOwners.Update ]
                }

            },

            queryActions: {
                endpoint: TractorOwnerEndpoints.getUrl()
            },


            filters: [
                {
                    key: "type",
                    query: "account_type",
                    name: "Account Type",
                    apply: true,
                    fromQuery: value => {

                        if(isFinite(value)){
                            return Number(value);
                        }

                        switch ((value || "").toLowerCase()) {
                            case "individual":
                                return OwnerAccountType.Individual;
                            case "company":
                                return  OwnerAccountType.Company;
                        }
                    },
                    renderValue: value => {

                        switch (Number(value)) {
                            case OwnerAccountType.Individual:
                                return "Individual";
                            case OwnerAccountType.Company:
                                return "Company";
                        }
                    }
                },
                {
                    key: "user.phone",
                    query: "phone",
                    operator: "[]",
                    apply: true
                },
                {
                    key: "user.email",
                    query: "email",
                    operator: "[]",
                    apply: true
                },
                {
                    key: "name",
                    query: "name",
                    operator: "[]",
                    apply: true
                }
            ],

            renderCustomFilters: ({ applyFilters , toggle , values , setValue , setValues , resetValues }) => {

                return <CustomFilterFrame toggle={toggle}>

                    <Row className="mb-1">
                        <Col md={3}>

                            <b>Name</b>
                            <input name="name"
                                   value={values['name']}
                                   onChange={evt => {
                                       setValue('name',evt.target.value);
                                   }}
                                   type="text"
                                   className="form-control form-input-select"
                                   placeholder="Search name"/>

                        </Col>

                        <Col md={3}>

                            <b>Phone</b>
                            <input name="phone"
                                   value={values['phone']}
                                   onChange={evt => {
                                       setValue('phone',evt.target.value);
                                   }}
                                   type="text"
                                   className="form-control form-input-select"
                                   placeholder="Search phone number"/>

                        </Col>

                        <Col md={3}>

                            <b>Email</b>
                            <input name="email"
                                   value={values['email']}
                                   onChange={evt => {
                                       setValue('email',evt.target.value);
                                   }}
                                   type="text"
                                   className="form-control form-input-select"
                                   placeholder="Search email"/>

                        </Col>


                    </Row>

                    <hr/>

                    <div className="clearfix">

                        <div className="pull-left">
                            <Button onClick={() => resetValues() }><i className="fa fa-refresh"/> Reset Filters</Button>
                        </div>

                        <div className="pull-right">
                            <Button color="green" style={{ borderRadius: 4 }} onClick={() => {

                                let _targetFilter = { };
                                Object.keys(values).forEach(k => {

                                    let _v = values[k];
                                    if(!_.isNil(_v) && _v !== ""){
                                        switch (k) {

                                            case "phone":
                                            case "email":
                                                k = `user.${k}`;
                                                break;
                                        }
                                        _targetFilter[k] = _v;
                                    }
                                    else{
                                        _targetFilter[k] = undefined;
                                    }

                                });

                                applyFilters(_targetFilter);


                            }}><i className="fa fa-check"/> Apply</Button>
                        </div>
                    </div>

                </CustomFilterFrame>
            },


            search:{

                //
                placeholder: 'Search tractor owners...',

                //  the mode for searching
                //  immediate: responsive
                //  explicit: wait till user hits the search button
                mode: 'explicit',

                //  The minimum characters to begin search with
                minSearchChars: 2,

                properties: SearchProps

            },

            hooks: {

                postProcessorHook: (action,response) => {
                   Utils.eraseSession(CacheDependency);
                },

                renderCellActions: (item) => {

                    return [

                        {
                            label: "Tractor/Operator",
                            icon: "fa fa-plus",
                            onClick: () => {
                                return me._createTractorDlg.show({  owner: item });
                            }
                        },

                        {
                            label: "View Requests",
                            icon: "fa fa-eye",
                            onClick: () => {
                                return Utils.navigateLink(`/requests?owner_id=${encodeURIComponent(item.id.toString())}&_owner_select_name=${encodeURIComponent(item.name)}`);
                            }
                        },
                        {
                            label: "Show Tractors",
                            icon: "fa fa-eye",
                            onClick: () => {
                                return Utils.navigateLink(`/tractors?owner_id=${encodeURIComponent(item.id.toString())}&_owner_select_name=${encodeURIComponent(item.name)}`);
                            }
                        },
                        {
                            label: "Manage Wallets",
                            icon: "fa fa-credit-card",
                            permissions: [ Permissions.Wallet.Manage ],
                            onClick: () => {
                                this._walletManagementDlg.show(item.user);
                            }
                        }

                    ]
                }
            },

            //  Defines actions for toolbox
            toolBox: [
                { text: 'Add Tractor Owner',  icon: 'fa fa-plus', invoke: () => me.beginShowCreate() , position: 'right', permissions:  [ Permissions.TractorOwners.Create ] },
                {  text : 'Refresh'  , icon : 'fa fa-refresh'  , invoke: () => me.refresh() , position: 'right' },
                {  text : 'Account Type'  , icon : 'fa fa-user' , invoke: (index) => { me.updateQuery('type',index,true) }, position: 'right' , group : 'filter' , items: AccountTypeMap },
                {  text : null  , icon : 'fa fa-sort' , invoke: (index) => { me.configureSort();  }, position: 'right' , group : 'filter'},
                {  text : ''  , icon : 'fa fa-gears' , invoke: (index) => {

                    switch (index){
                        case 0:
                            return exportFilteredCSV(TractorOwnerEndpoints.exportCSV(),{ component: me });
                        case 1:
                            return  me.toggleCustomFilterVisibility();
                    }

                }, position: 'right' , group : 'more' ,
                    items: () => ([
                        <span><i className="fa fa-file-text"></i> Export to CSV</span>,
                        <span><i className={me.isCustomFilterViewVisible() ? "fa fa-chevron-up" : "fa fa-chevron-down"}/> {me.isCustomFilterViewVisible() ? "Hide" : "Show"} Advanced Filters</span>
                    ]),
                    sticky: false,
                }

            ],

            //  Inputs used in editing and creating items
            inputsCreate: this.getCreateInputs(),

            inputsEdit: this.getEditInputs(),
            //
            model: {
                include: ['operators' , 'tractors' , 'user' , 'media' ]
            },

            sort: {

                properties: [
                    {
                        label: "Date Added",
                        value: "date_created"
                    },
                    {
                        label: "Name",
                        value: "name"
                    },
                    {
                        label: "Phone",
                        value: "user.phone"
                    }
                ]
            },


            // Describes the columns present in the table
            columns : [
                {key: '__img' , label: ' ' , cell: (item,k) => <Avatar src={Utils.getProfileImage(item.media)} name={Utils.formatAvatarName(item.name)}  size={32} />  , mobile: true },
                {key:'name', label:() => me.sortCol('Name','name') , mobile: true },
                {key:'type', label: 'Account Type' , format : AccountTypeMap },
                {key:'phone', label: () => me.sortCol('Phone No.','user.phone') , format: (value,item) => (item.user && item.user.phone) ? item.user.phone : "N/A", mobile: true },
                {key: 'tractors' , label: 'No. Tractors' , format: (tractors) => tractors ? tractors.length : 0 , mobile: true },
            ],

            //  Describes details to show when clicked
            detailsDisplay: {

                //  enable or disable
                enabled: true,

                renderTitle: (item) => {
                    return 'Tractor Owner Info';
                },

                customRender: (item) =>{

                    const me = this;
                    return <div>
                        <div className="text-center">
                            <h5>Profile Image</h5>
                            <EntityImageDisplay
                                entityName="owner"
                                entityId={item.id}
                                crudView={me}
                                onRemove={(media) => {
                                    me.updateItemMedia(item,media);
                                }}
                                onCompleteUpload={(media) => {
                                    me.updateItemMedia(item,media);
                                    return false;
                                }}
                                media={item.media} />
                        </div>

                        <div>

                            <DialogCollapseSection initiallyOpen={true} title="Info">

                                <div className="row">
                                    <div className="col-md-6">
                                        <dl>

                                            <dt>Username</dt>
                                            <dd>{item.user.name}</dd>

                                            <dt>Name</dt>
                                            <dl>{item.name}</dl>

                                            <dt>Account Type</dt>
                                            <dd>{AccountTypeMap[item.type]}</dd>

                                            <dt>Location</dt>
                                            <dd>{item.location}</dd>

                                        </dl>
                                    </div>
                                    <div className="col-md-6">
                                        <dl>
                                            <dt>Phone</dt>
                                            <dd>{(item.user && item.user.phone) ? Utils.standardValue(item.user.phone) : "N/A" }</dd>

                                            <dt>Email</dt>
                                            <dd>{item.user ? Utils.standardValue(item.user.email) : "N/A" }</dd>

                                            <dt>Date Registered</dt>
                                            <dd>{Utils.formatDateStandard( item.user.date_created )}</dd>

                                        </dl>
                                    </div>
                                </div>
                            </DialogCollapseSection>

                            <DialogCollapseSection title="Tractors">

                                <DataList data={item.tractors}
                                          columns={me.getTractorColumns(item)}
                                          hover
                                          responsive
                                          itemsPerPage={5}
                                          noRowsMessage={"No tractors available"}/>

                            </DialogCollapseSection>

                        </div>

                    </div>
                }

            },

            //  Processors
            processors : {

                //  create new item
                createItem: (proxy , payload) => {

                    //  Create tractor owner
                    return proxy.processRequest(UsersEndpoints.registerTractorOwnerAccount(false, true  , {
                        username: payload.username,
                        email: payload.email,
                        phone: payload.phone,
                        password: payload.password  || `${payload.username}@trotrotractor` ,
                        owner: {
                            name: payload.name,
                            location: payload.location ,
                            location_lat: payload.location_lat,
                            location_long: payload.location_long,
                            type: payload.type
                        }
                    }))
                },

                //  called to delete many items
                deleteMany: (proxy,items) => {
                    return proxy.processRequest(TractorOwnerEndpoints.deleteTractorOwner(items.map((item) => item.id)));
                },

                //  on edit item
                onEditItem: (proxy,item, inputs) => {

                    const user = item.user;
                    inputs.email = inputs.email || null;

                    function updateAccount() {

                        return proxy.processRequest(UsersEndpoints.updateUser(item.user.id,{
                            username: inputs.username,
                            email: inputs.email,
                            phone: inputs.phone,
                            last_updated: item.user.last_updated
                        }));

                    }

                    function updateOwner() {

                        return proxy.processRequest(TractorOwnerEndpoints.updateOwner(item.id , {
                            name: inputs.name,
                            location: inputs.location,
                            location_lat: inputs.location_lat,
                            location_long: inputs.location_long,
                            type: inputs.type,
                            last_updated: item.last_updated
                        }));

                    }

                    let promise = [];
                    if( ( inputs.username != user.username ) || (inputs.email != user.email) || (inputs.phone != user.phone) ){
                        promise.push(updateAccount());
                    }

                    if((inputs.name != item.name) || (inputs.location != item.location) || (inputs.type != item.type) || (inputs.location_lat != item.location_lat) || (inputs.location_long != item.location_long)){
                        promise.push(updateOwner());
                    }


                    return Promise.all(promise).then(values => {
                        return values[0];
                    });
                },


                //  on delete item
                onDeleteItem: ( proxy,item ) => {
                    return proxy.processRequest(TractorOwnerEndpoints.deleteTractorOwner(item.id));
                }
            }
        });
    }



}

export default TractorOwnersAdmin;



// WEBPACK FOOTER //
// ./src/views/Tractorowners/TractorOwners.js